module.exports = __webpack_public_path__ + "static/media/sms.c1cd5101.svg";